export const column = [
  { key: '2', headerName: 'ID/code', field: 'id', hide: false, width: 120 },
  {
    key: '3', headerName: 'Version', field: 'version_code', hide: false, width: 180
  },
  {
    key: '3', headerName: 'Created Date', field: 'currentDate', hide: false, width: 200
  },
  { key: '3', headerName: 'Valid From', field: 'from_date', hide: false, width: 200 },
  { key: '4', headerName: 'Valid TO', field: 'to_date', hide: false, width: 200 },
  { key: '4', headerName: 'Status', field: 'status', hide: false, width: 200 }
];
